import storage from '../services/storage';

export default function getSessionId() {
  return storage.session.getItem('CheckoutPage.sessionId');
}
